var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-button',{staticClass:"folder-btn flex flex-cross--center flex-main--center",style:(_setup.styleObj)},[_c('i',{staticClass:"iconfont icon-arrow",attrs:{"id":"close_amend_nickname_btn"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }